import styled from 'styled-components';

export default styled.svg`
  @media (prefers-reduced-motion: no-preference) {
    .envelope-smiling {
      animation: envelopeRock ease-in-out 2s alternate infinite;
      transform-origin: 50% 50%;
    }

    .envelope-left {
      animation: envelopeBob ease-in-out 4s alternate infinite;
    }

    .envelope-right {
      animation: envelopeBob ease-in-out 5s alternate infinite;
      animation-delay: -4s;
    }

    .dot-left {
      animation: fadeIn ease-in-out 3s alternate infinite;
    }

    .dot-right {
      animation: fadeIn ease-in-out 4s alternate infinite;
      animation-delay: -2s;
    }

    .circle-right {
      animation: drawIn ease-in-out 4s alternate infinite;
    }

    .circle-left {
      animation: drawIn ease-in-out 4s alternate infinite;
      animation-delay: -2s;
    }
  }

  ${props => props.theme.animations.envelopeRock};
  ${props => props.theme.animations.envelopeBob};
  ${props => props.theme.animations.fadeIn};
  ${props => props.theme.animations.drawIn};
`;
